import { InMemoryCache, defaultDataIdFromObject, createHttpLink, ApolloClient } from "@apollo/client";
import { setContext } from '@apollo/client/link/context';
import { VITE_HAPPYDOC_INSIGHTS_SERVER_URL } from "../utils/env";
import { supabase } from "./supabase";

const cache = new InMemoryCache({
    dataIdFromObject(responseObject) {
        if ('nodeId' in responseObject) {
            return `${responseObject.nodeId}`
        }
        return defaultDataIdFromObject(responseObject)
    },
})

const httpLink = createHttpLink({
    uri: `${VITE_HAPPYDOC_INSIGHTS_SERVER_URL}/api/v2/graphql`,
});

const authLink = setContext(async (_, { headers }) => {
    const token = (await supabase.auth.getSession()).data.session?.access_token
    return {
        headers: {
            ...headers,
            Authorization: token ? `Bearer ${token}` : '',
        },
    }
})
const apolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache,
})

export default apolloClient